import { BACKEND_URL_PREFIX } from "../utils/const";
import {
  SET_DASHBOARD_LOADING,
  SET_DASHBOARD_DATA,
  SET_DASHBOARD_DETAILS_VSOKO,
  SET_DASHBOARD_DETAILS_EIOC,
  SET_DASHBOARD_DETAILS_EGE,
  SET_DASHBOARD_DETAILS_TEACHERS,
  SET_DASHBOARD_DETAILS_STAFF,
  SET_DASHBOARD_DETAILS_STUDENTS,
  SET_DASHBOARD_CIUP_DATA,
} from "./types";
import { buildDefaultHeaders } from "./helper";
import { saveAs } from 'file-saver';
import { objFilter } from "../utils/smallHelpers";


export const getData = (discipline_name) => async (dispatch, getState) => {
  
  dispatch({ type: SET_DASHBOARD_LOADING, payload: true })
  const params = objFilter({ discipline_name });
  const stringParams = new URLSearchParams(params).toString();
  const response = await fetch(`${BACKEND_URL_PREFIX}/dashboard/ap/stats?${stringParams}`,
    buildDefaultHeaders(getState)
  );
  
  if (response.ok) {
    const payload = await response.json();
    dispatch({ type: SET_DASHBOARD_DATA, payload });
  }
  
  dispatch({ type: SET_DASHBOARD_LOADING, payload: false })
};

export const getCollegeData = (discipline_name) => async (dispatch, getState) => {
  
  dispatch({ type: SET_DASHBOARD_LOADING, payload: true })
  const params = objFilter({ discipline_name });
  const stringParams = new URLSearchParams(params).toString();
  const response = await fetch(`${BACKEND_URL_PREFIX}/dashboard/ap/college?${stringParams}`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const payload = await response.json();
    dispatch({ type: SET_DASHBOARD_DATA, payload });
  }

  dispatch({ type: SET_DASHBOARD_LOADING, payload: false })
};


export const getEiocDetails = (id, spoMode) => async (dispatch, getState) => {
  
  dispatch({ type: SET_DASHBOARD_LOADING, payload: true })
  const postfix = spoMode ? '/college' : '';
  const response = await fetch(`${BACKEND_URL_PREFIX}/dashboard/ap/eioc/${id}${postfix}`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const payload = await response.json();
    dispatch({ type: SET_DASHBOARD_DETAILS_EIOC, payload });
  }

  dispatch({ type: SET_DASHBOARD_LOADING, payload: false })
};


export const getVsokoDetails = (id) => async (dispatch, getState) => {
  
  dispatch({ type: SET_DASHBOARD_LOADING, payload: true })
  const response = await fetch(`${BACKEND_URL_PREFIX}/dashboard/ap/vsoko/${id}`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const payload = await response.json();
    dispatch({ type: SET_DASHBOARD_DETAILS_VSOKO, payload });
  }

  dispatch({ type: SET_DASHBOARD_LOADING, payload: false })
};


export const getEgeDetails = (id) => async (dispatch, getState) => {
  
  dispatch({ type: SET_DASHBOARD_LOADING, payload: true })
  const response = await fetch(`${BACKEND_URL_PREFIX}/dashboard/ap/ege_stats/subjects/${id}`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const payload = await response.json();
    dispatch({ type: SET_DASHBOARD_DETAILS_EGE, payload });
  }

  dispatch({ type: SET_DASHBOARD_LOADING, payload: false })
};


export const getEgeStudents = (id, filters) => async (dispatch, getState) => {
  
  // dispatch({ type: SET_DASHBOARD_LOADING, payload: true })
  const params = objFilter(filters)
  const stringParams = new URLSearchParams(params).toString();
  const response = await fetch(`${BACKEND_URL_PREFIX}/dashboard/ap/ege_stats/people/${id}?${stringParams}`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const students = await response.json();
    const payload = { students }; 
    dispatch({ type: SET_DASHBOARD_DETAILS_EGE, payload });
  }

  // dispatch({ type: SET_DASHBOARD_LOADING, payload: false })
};


export const getTeachersDetails = (id) => async (dispatch, getState) => {
  
  dispatch({ type: SET_DASHBOARD_LOADING, payload: true })
  const response = await fetch(`${BACKEND_URL_PREFIX}/dashboard/ap/teachers/degree/${id}`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const payload = await response.json();
    dispatch({ type: SET_DASHBOARD_DETAILS_TEACHERS, payload });
  }

  dispatch({ type: SET_DASHBOARD_LOADING, payload: false })
}


export const getTeachersList = (id, filters) => async (dispatch, getState) => {
  
  // dispatch({ type: SET_DASHBOARD_LOADING, payload: true })
  const params = objFilter(filters)
  const stringParams = new URLSearchParams(params).toString();
  const response = await fetch(`${BACKEND_URL_PREFIX}/dashboard/ap/teachers/staff/${id}?${stringParams}`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const teachers = await response.json();
    const payload = { teachers };
    dispatch({ type: SET_DASHBOARD_DETAILS_TEACHERS, payload });
  }

  // dispatch({ type: SET_DASHBOARD_LOADING, payload: false })
}


export const getStaffDetails = (id, spoMode) => async (dispatch, getState) => {
  
  dispatch({ type: SET_DASHBOARD_LOADING, payload: true })
  const postfix = spoMode ? '/college' : '';
  const response = await fetch(`${BACKEND_URL_PREFIX}/dashboard/ap/workers/stage/${id}${postfix}`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const payload = await response.json();
    dispatch({ type: SET_DASHBOARD_DETAILS_STAFF, payload });
  }

  dispatch({ type: SET_DASHBOARD_LOADING, payload: false })
}


export const getStaffList = (id, filters) => async (dispatch, getState) => {
  
  // dispatch({ type: SET_DASHBOARD_LOADING, payload: true })
  const params = objFilter(filters)
  const stringParams = new URLSearchParams(params).toString();
  const response = await fetch(`${BACKEND_URL_PREFIX}/dashboard/ap/teachers/staff/${id}?${stringParams}`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const list = await response.json();
    const payload = { list };
    dispatch({ type: SET_DASHBOARD_DETAILS_STAFF, payload });
  }

  dispatch({ type: SET_DASHBOARD_LOADING, payload: false })
}

export const getStudentsDetails = (id, spoMode, filters) => async (dispatch, getState) => {
  
  dispatch({ type: SET_DASHBOARD_LOADING, payload: true })
  const params = objFilter(filters)
  const stringParams = new URLSearchParams(params).toString();
  const postfix = spoMode ? '/college' : '';
  const response = await fetch(`${BACKEND_URL_PREFIX}/dashboard/ap/students/stats/${id}${postfix}?${stringParams}`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const payload = await response.json();
    dispatch({ type: SET_DASHBOARD_DETAILS_STUDENTS, payload });
  }

  dispatch({ type: SET_DASHBOARD_LOADING, payload: false })
}


export const getPhoto = (id) => async (dispatch, getState) => {

  let photoUrl = '';

  const response = await fetch(`${BACKEND_URL_PREFIX}/users/${id}/photo`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const blob = await response.blob();
    photoUrl = URL.createObjectURL(blob);
  }

  return photoUrl
}

export const getCiupData = (mode, criterion) => async (dispatch, getState) => {
  
  dispatch({ type: SET_DASHBOARD_LOADING, payload: true })
  const response = await fetch(`${BACKEND_URL_PREFIX}/dashboard/ciup/${mode}/${criterion}`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const respData = await response.json();
    const payload = {[criterion]: respData};
    dispatch({ type: SET_DASHBOARD_CIUP_DATA, payload });
  }

  dispatch({ type: SET_DASHBOARD_LOADING, payload: false })
}

export const getFile = async (docId, fileName) => {

  const response = await fetch(`${BACKEND_URL_PREFIX}/dashboard/ap/${docId}/${fileName}`);

  if (response.ok) {
    const blob = await response.blob();
    saveAs(blob, fileName);
  }
}

export const getSelfExFile = async (docId, fileName) => {

  const response = await fetch(`${BACKEND_URL_PREFIX}/dashboard/ap/${docId}/${fileName}/self_ex`);

  if (response.ok) {
    const blob = await response.blob();
    saveAs(blob, fileName);
  }
}